import {
  Alert,
  Button,
  Card,
  Label,
  Table,
  TextInput,
  Timeline,
} from "flowbite-react";
import React, { useEffect, useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { FaSearch } from "react-icons/fa";
import { isValidCPF } from "../../utils/utils";
import axios from "../../config/axiosInstance";
import { QUERIES } from "../../config/apiConfig";
import { maskCPF } from "../../utils/masks";
import { HiInformationCircle } from "react-icons/hi";
import HeaderQuery from "./HeaderQuery";
import CardQueryDescription from "../common/CardQueryDescription";
import QueryLoading from "../common/QueryLoading";
import TitleStripe from "../common/TitleStripe";
import NoOcurrence from "../common/query/NoOcurrence";

const CadastralPFQuery = ({
  query,
  selectedPrice,
  dataFromLocalStorage = null,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [info, setInfo] = useState("");
  const [error, setError] = useState("");
  const [errorQuery, setErrorQuery] = useState("");
  const [data, setData] = useState(null);

  useEffect(() => {
    if (dataFromLocalStorage) {
      setData(dataFromLocalStorage);
    }
  }, []);

  const handleChange = (event) => {
    let valor = event.target.value.replace(/\D/g, "");

    valor = maskCPF(valor);

    setInfo(valor);
  };

  const fetchInfo = async (raw) => {
    return await axios(
      `${QUERIES.GET_V2_QUERY}/avalie-cadastral-pf/${info.replace(/\D/g, "")}`
    );
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const unmaskedValue = info.replace(/\D/g, "");
    let isValid = true;

    if (!isValidCPF(unmaskedValue)) {
      setError("CPF inválido!");
      isValid = false;
    }

    if (isValid) {
      try {
        setData(null);
        setIsLoading(true);
        setError("");
        setErrorQuery("");
        const { data: dados } = await fetchInfo();
        setData(dados.data);
      } catch (error) {
        setErrorQuery(
          typeof error?.response?.data?.message !== "object"
            ? error?.response?.data?.message
            : "Algum erro ocorreu com sua consulta"
        );
      } finally {
        setIsLoading(false);
      }
    } else {
      setData(null);
    }
  };

  return (
    <>
      {!dataFromLocalStorage && (
        <>
          <div className="text-lg font-semibold mb-3 title-syncx">
            {query?.name}
          </div>
          <CardQueryDescription
            title="Informações da consulta"
            infos={[
              "Dados Cadastrais",
              "Dados profissionais",
              "Endereços",
              "E-mails",
              "Telefones",
            ]}
            price={selectedPrice}
          >
            <form
              className="flex flex-col gap-2 bg-white p-2 mt-2 rounded-lg shadow-md w-fit"
              onSubmit={handleSubmit}
            >
              <div className="flex gap-2 items-center">
                <div className="flex items-center gap-2">
                  <div className="block">
                    <Label htmlFor="info" value="CPF:" />
                  </div>
                  <TextInput
                    id="info"
                    type="text"
                    required
                    onChange={handleChange}
                    maxLength="14"
                    value={info}
                  />
                </div>
                <Button
                  className=" shadow-lg primary flex items-center justify-center"
                  type="submit"
                  isProcessing={isLoading}
                  processingSpinner={
                    <CgSpinner className="h-5 w-5 animate-spin" />
                  }
                  style={{ height: "43px" }}
                >
                  <FaSearch />
                </Button>
              </div>
              {error && <small className="text-red-600">{error}</small>}
            </form>
          </CardQueryDescription>
        </>
      )}

      {errorQuery ? (
        <Alert color="failure" icon={HiInformationCircle}>
          <span className="font-medium">{errorQuery}</span>
        </Alert>
      ) : (
        <div className={`${data || isLoading ? "block" : "hidden"}`}>
          {!isLoading ? (
            <Card className="overflow-hidden relative">
              <HeaderQuery title={query?.name} />
              <TitleStripe>Dados cadastrais</TitleStripe>
              <div className="grid grid-cols-2 gap-4">
                <div>
                  <div className="mb-3">
                    <span className="font-semibold">Status do CPF: </span>
                    {data?.situacao || "Sem info."}
                  </div>
                  <div className="mb-3">
                    <span className="font-semibold">Nome completo: </span>
                    {data?.nome || "Sem info."}
                  </div>
                  <div className="mb-3">
                    <span className="font-semibold">CPF: </span>
                    {data?.cpf}
                  </div>
                  <div className="mb-3">
                    <span className="font-semibold">Signo: </span>
                    {data?.signo}
                  </div>
                  <div className="mb-3">
                    <span className="font-semibold">Aposentado: </span>
                    {data?.aposentado}
                  </div>
                </div>
                <div>
                  <div className="mb-3">
                    <span className="font-semibold">Sexo: </span>
                    {data?.sexo || "Sem info."}
                  </div>
                  <div className="mb-3">
                    <span className="font-semibold">Data de nascimento: </span>
                    {data?.dataNascimento}
                  </div>
                  <div className="mb-3">
                    <span className="font-semibold">Nome da mãe: </span>
                    {data?.nomeMae || "Sem info."}
                  </div>
                  <div className="mb-3">
                    <span className="font-semibold">PEP: </span>
                    {data?.pep}
                  </div>
                </div>
              </div>

              <div>
                <TitleStripe className="mb-5">
                  Histórico trabalhista
                </TitleStripe>
                {data?.historicoTrabalhista?.length > 0 ? (
                  <Timeline>
                    <>
                      {data?.historicoTrabalhista?.map((emprego, index) => (
                        <Timeline.Item key={index}>
                          <Timeline.Point />
                          <Timeline.Content>
                            <Timeline.Time>CNPJ: {emprego.cnpj} </Timeline.Time>
                            <Timeline.Title>
                              Empresa: {emprego.empresa}
                            </Timeline.Title>
                          </Timeline.Content>
                        </Timeline.Item>
                      ))}
                    </>
                  </Timeline>
                ) : (
                  <NoOcurrence />
                )}
              </div>

              <div>
                <TitleStripe className="mb-5">
                  Participação em empresas
                </TitleStripe>
                {data?.sociedades?.length > 0 ? (
                  <Timeline>
                    <>
                      {data?.sociedades?.map((empresa, index) => (
                        <Timeline.Item key={index}>
                          <Timeline.Point />
                          <Timeline.Content>
                            <Timeline.Time>CNPJ: {empresa.cnpj} </Timeline.Time>
                            <Timeline.Title>
                              Empresa: {empresa.empresa}
                            </Timeline.Title>
                            <Timeline.Body>
                              <div>
                                Participação:{" "}
                                {empresa.participacaoEmPorcentagem}
                              </div>
                              <div>Cargo: {empresa.funcao}</div>
                            </Timeline.Body>
                          </Timeline.Content>
                        </Timeline.Item>
                      ))}
                    </>
                  </Timeline>
                ) : (
                  <NoOcurrence />
                )}
              </div>

              <div>
                <TitleStripe className="mb-3">
                  Histórico de endereços
                </TitleStripe>
                {data?.enderecos?.length > 0 ? (
                  <>
                    <div className="overflow-x-hidden shadow-sm rounded-lg mt-5 text-sm">
                      <Table striped>
                        <Table.Head>
                          <Table.HeadCell className="bg-gray-300 p-2">
                            Endereço
                          </Table.HeadCell>
                          <Table.HeadCell className="text-center bg-gray-300 p-2">
                            Bairro
                          </Table.HeadCell>
                          <Table.HeadCell className="text-center bg-gray-300 p-2">
                            Cidade:
                          </Table.HeadCell>
                          <Table.HeadCell className="text-center bg-gray-300 p-2">
                            CEP:
                          </Table.HeadCell>
                          <Table.HeadCell className="text-center bg-gray-300 p-2">
                            Prioridade:
                          </Table.HeadCell>
                        </Table.Head>

                        <Table.Body className="divide-y">
                          {data?.enderecos?.map((endereco, index) => (
                            <Table.Row
                              key={index}
                              className="bg-white dark:border-gray-700 dark:bg-gray-800"
                            >
                              <Table.Cell className="font-medium text-gray-900 dark:text-white p-2">
                                {endereco.endereco} Nº {endereco.numero}
                              </Table.Cell>
                              <Table.Cell className="text-center p-2">
                                {endereco.bairro}
                              </Table.Cell>
                              <Table.Cell className="text-center p-2">
                                {endereco.cidade}
                              </Table.Cell>
                              <Table.Cell className="text-center p-2">
                                {endereco.cep}
                              </Table.Cell>
                              <Table.Cell className="text-center p-2">
                                {endereco.prioridade}
                              </Table.Cell>
                            </Table.Row>
                          ))}
                        </Table.Body>
                      </Table>
                    </div>
                  </>
                ) : (
                  <NoOcurrence />
                )}
              </div>
              <div>
                <TitleStripe className="mb-3">Histórico de emails</TitleStripe>
                {data?.emails?.length > 0 ? (
                  <>
                    <div className="overflow-x-hidden shadow-sm rounded-lg mt-5 text-sm">
                      <Table striped>
                        <Table.Head>
                          <Table.HeadCell className="bg-gray-300 p-2">
                            Email
                          </Table.HeadCell>
                          <Table.HeadCell className="text-center bg-gray-300 p-2">
                            Prioridade
                          </Table.HeadCell>
                        </Table.Head>

                        <Table.Body className="divide-y">
                          {data?.emails?.map((email, index) => (
                            <Table.Row
                              key={index}
                              className="bg-white dark:border-gray-700 dark:bg-gray-800"
                            >
                              <Table.Cell className="font-medium text-gray-900 dark:text-white p-2">
                                {email.email}
                              </Table.Cell>
                              <Table.Cell className="text-center p-2">
                                {email.prioridade}
                              </Table.Cell>
                            </Table.Row>
                          ))}
                        </Table.Body>
                      </Table>
                    </div>
                  </>
                ) : (
                  <NoOcurrence />
                )}
              </div>

              <div>
                <TitleStripe className="mb-3">
                  Histórico de telefones
                </TitleStripe>
                {data?.telefones?.length > 0 ? (
                  <>
                    <div className="overflow-x-hidden shadow-sm rounded-lg mt-5 text-sm">
                      <Table striped>
                        <Table.Head>
                          <Table.HeadCell className="bg-gray-300 p-2 text-center">
                            DDD
                          </Table.HeadCell>
                          <Table.HeadCell className="text-center bg-gray-300 p-2">
                            Número
                          </Table.HeadCell>
                          <Table.HeadCell className="text-center bg-gray-300 p-2">
                            Prioridade:
                          </Table.HeadCell>
                        </Table.Head>

                        <Table.Body className="divide-y">
                          {data?.telefones?.map((telefone, index) => (
                            <Table.Row
                              key={index}
                              className="bg-white dark:border-gray-700 dark:bg-gray-800"
                            >
                              <Table.Cell className="font-medium text-gray-900 dark:text-white p-2 text-center">
                                {telefone.ddd}
                              </Table.Cell>
                              <Table.Cell className="text-center p-2">
                                {telefone.numero}
                              </Table.Cell>
                              <Table.Cell className="text-center p-2">
                                {telefone.prioridade}
                              </Table.Cell>
                            </Table.Row>
                          ))}
                        </Table.Body>
                      </Table>
                    </div>
                  </>
                ) : (
                  <NoOcurrence />
                )}
              </div>

              <div>
                <TitleStripe className="mb-3">
                  Histórico de celulares
                </TitleStripe>
                {data?.celulares?.length > 0 ? (
                  <>
                    <div className="overflow-x-hidden shadow-sm rounded-lg mt-5 text-sm">
                      <Table striped>
                        <Table.Head>
                          <Table.HeadCell className="bg-gray-300 p-2 text-center">
                            DDD
                          </Table.HeadCell>
                          <Table.HeadCell className="text-center bg-gray-300 p-2">
                            Número
                          </Table.HeadCell>
                          <Table.HeadCell className="text-center bg-gray-300 p-2">
                            Prioridade:
                          </Table.HeadCell>
                        </Table.Head>

                        <Table.Body className="divide-y">
                          {data?.celulares?.map((telefone, index) => (
                            <Table.Row
                              key={index}
                              className="bg-white dark:border-gray-700 dark:bg-gray-800"
                            >
                              <Table.Cell className="font-medium text-gray-900 dark:text-white p-2 text-center">
                                {telefone.ddd}
                              </Table.Cell>
                              <Table.Cell className="text-center p-2">
                                {telefone.numero}
                              </Table.Cell>
                              <Table.Cell className="text-center p-2">
                                {telefone.prioridade}
                              </Table.Cell>
                            </Table.Row>
                          ))}
                        </Table.Body>
                      </Table>
                    </div>
                  </>
                ) : (
                  <NoOcurrence />
                )}
              </div>
            </Card>
          ) : (
            <QueryLoading />
          )}
        </div>
      )}
    </>
  );
};

export default CadastralPFQuery;
